import axios from 'axios';
import {base_api} from './base';

export function getParticipants() {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.get(`${base_api}/Participants`, {headers});
}

export function getByBarCode(barcode) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.get(`${base_api}/Participants/GetByBarCode?barcode=${barcode}`, {headers});
}

export function getByEventId(id) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.get(`${base_api}/Participants/GetByEventId?id=${id}`, {headers});
}

export function addParticipant(data) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.post(`${base_api}/Participants/AddParticipant`, data, {headers});
}

export function addParticipantList(data) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.post(`${base_api}/Participants/AddParticipantList`, data, {headers});
}

export function updateParticipant(id, data) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.put(`${base_api}/Participants/UpdateParticipant?id=${id}`, data, {headers});
}

export function updateParticipantList(eventId, data) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.put(`${base_api}/Participants/UpdateParticipantList?eventId=${eventId}`, data, {headers});
}

export function deleteParticipant(id) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.delete(`${base_api}/Participants/DeleteParticipant?id=${id}`, {headers});
}

export function deleteParticipantList(eventId) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.delete(`${base_api}/Participants/DeleteParticipantList?eventId=${eventId}`, {headers});
}



// WEBPACK FOOTER //
// ./src/services/Participants.service.js